module.exports = __webpack_public_path__ + "static/media/promotionModal.f56465f0.svg";